import { render } from "./readingGuide.vue?vue&type=template&id=e4518e52&scoped=true"
import script from "./readingGuide.vue?vue&type=script&lang=js"
export * from "./readingGuide.vue?vue&type=script&lang=js"

import "./readingGuide.vue?vue&type=style&index=0&id=e4518e52&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4518e52"]])

export default __exports__